import { render, staticRenderFns } from "./SearchV1.vue?vue&type=template&id=0dd57d02"
import script from "./SearchV1.vue?vue&type=script&lang=js"
export * from "./SearchV1.vue?vue&type=script&lang=js"
import style0 from "./SearchV1.vue?vue&type=style&index=0&id=0dd57d02&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd57d02')) {
      api.createRecord('0dd57d02', component.options)
    } else {
      api.reload('0dd57d02', component.options)
    }
    module.hot.accept("./SearchV1.vue?vue&type=template&id=0dd57d02", function () {
      api.rerender('0dd57d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/search/SearchV1.vue"
export default component.exports